import { render, staticRenderFns } from "./DeliveryShr.vue?vue&type=template&id=799740a8&scoped=true&"
import script from "./DeliveryShr.vue?vue&type=script&lang=js&"
export * from "./DeliveryShr.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryShr.vue?vue&type=style&index=0&id=799740a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799740a8",
  null
  
)

export default component.exports